<template>
  <div>
      <TabView>
        <TabPanel header="Menu">
            <div class="p-fluid p-formgrid p-grid">					
                <div class="p-field p-col" v-if="!principal">
                    <label>Menu Pai</label>
                    <InputText v-model="menuPai.nome" class="p-text-bold" disabled/>
                </div>
            </div>  
            <div class="p-fluid p-formgrid p-grid">					
                <div class="p-field p-col">
                    <label for="nome">Nome</label>
                    <InputText id="nome" v-model.trim="menu.nome" required="true" autocomplete="off" maxlength="40"/>
                    <small class="p-invalid" v-if="enviandoForm && !menu.nome">Informe o nome</small>
                </div>
            </div>  
            <div class="p-fluid p-formgrid p-grid">					
                <div class="p-field p-col">
                        <div class="p-field-checkbox">
                        <Checkbox v-model="principal" :binary="true" @change="validarMenuPrinciapl"/>
                        <label>Principal</label>
                    </div>
                </div>                           
            </div>                       
        </TabPanel>
        <TabPanel header="Permissões">
            <div class="p-grid">
                <div class="p-col">
                    <Button icon="pi pi-plus" title="Nova Permissão" @click="exibirModalPermissao(true)"/>
                    <Button icon="pi pi-pencil" class="p-ml-2" title="Editar Permissão" 
                        :disabled="permissaoAtivaSelecionada == null" @click="exibirModalPermissao(false)"/>
                    <Button icon="pi pi-times" class="p-ml-2 p-button-warning" title="Desativar Permissão" 
                        :disabled="permissaoAtivaSelecionada == null" @click="desativarPermissao"/>
                    <Button icon="pi pi-trash" class="p-ml-2 p-button-danger" title="Excluir Permissão" 
                        :disabled="permissaoAtivaSelecionada == null" @click="excluirPermissao"/>
                </div>                           
            </div>
            <div class="p-fluid p-formgrid p-grid">					
                <div class="p-field p-col">                                
                    <Listbox v-model="permissaoAtivaSelecionada" :options="permissoesAtivasNovas" optionLabel="descricao" listStyle="height:180px"/>                                
                </div>
            </div>
        </TabPanel>
        <TabPanel header="Perm. Desativadas">
            <div class="p-grid">
                <div class="p-col">
                    <Button icon="pi pi-check" title="Reativar Permissão" :disabled="permissaoDesativadaSelecionada == null" @click="reativarPermissao"/>
                </div>                           
            </div>
            <div class="p-fluid p-formgrid p-grid">					
                <div class="p-field p-col">                                
                    <Listbox v-model="permissaoDesativadaSelecionada" :options="permissoesDesativadas" optionLabel="descricao" listStyle="height:180px" />                                
                </div>
            </div>
        </TabPanel>
        <TabPanel header="Perm. Excluir">
            <div class="p-grid">
                <div class="p-col">
                    <Button icon="pi pi-check" title="Reativar Permissão" :disabled="permissaoExcluirSelecionada == null" @click="cancelarExcluirPermissao"/>
                </div>                           
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col">                                
                    <Listbox v-model="permissaoExcluirSelecionada" :options="permissoesExcluir" optionLabel="descricao" listStyle="height:180px" />                                
                </div>
            </div>
        </TabPanel>
    </TabView>		
    <label>Permissões: <span class="p-text-bold">novas/ativas {{ permissoesAtivasNovas.length }}</span> 
        &nbsp;&nbsp;&nbsp;<span class="p-text-bold">desativadas {{ permissoesDesativadas.length }}</span>
        &nbsp;&nbsp;&nbsp;<span class="p-text-bold">excluir {{ permissoesExcluir.length }}</span>
    </label>    
    
    <!-- Modal para permissoes -->
    <Dialog :visible.sync="exibirDialogPermissao" :header="tituloPermissao" :modal="true" class="p-fluid" :style="{width: '500px'}" @hide="fecharModalPermissao">
        <div class="p-fluid p-formgrid p-grid">					
            <div class="p-field p-col">
                <label for="nomePermissao">Nome</label>
                <InputText id="nomePermissao" v-model.trim="permissao.nome" required="true" autocomplete="off" maxlength="50"/>
                <small class="p-invalid" v-if="enviandoForm && !permissao.nome">Informe o nome</small>
            </div>
        </div>  
        <div class="p-fluid p-formgrid p-grid">					
            <div class="p-field p-col">
                <label for="nomeAcao">Nome da Ação</label>
                <InputText id="nomeAcao" v-model.trim="permissao.nomeOperacao" required="true" autocomplete="off" maxlength="50"/>
                <small class="p-invalid" v-if="enviandoForm && !permissao.nomeOperacao">Informe o nome da ação</small>
            </div>
        </div>								
        <template #footer>
            <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModalPermissao"/>
            <Button label="Salvar" icon="pi pi-check" @click="incluirPermissao"/>
        </template>
    </Dialog>
     
  </div>
</template>

<script>

import { exibirMensagemSis, clonar } from '@/global';
import Menu from '@/model/Menu';
import Permissao from '@/model/Permissao';

export default {
    props: {
        receberDados: { type: Function, required: true, },
    },
    data() {
        return {
           indexIdTeste: 0,
           tituloPermissao: 'Nova Permissão',
           menuPai: null,
           menu: new Menu(),
           enviandoForm: false,
           principal: false,
           exibirDialogPermissao: false,
           permissao: new Permissao(),
           permissaoExcluirSelecionada: null,
           permissoesExcluir: [],
           permissaoDesativadaSelecionada: null,
           permissaoAtivaSelecionada: null,
           permissoesDesativadas: [],
           permissoesAtivasNovas: [],
        }
    },
    methods: {
        getDados() {
            this.enviandoForm = true;          
            if(this.menu.nome == '') {
                return null;
            }
            let dados = {
                isPrincipal: this.principal,
                permissoesAtivasNovas: this.permissoesAtivasNovas,
                permissoesDesativadas: this.permissoesDesativadas,
                permissoesExcluir: this.permissoesExcluir,
                menuPai: this.menuPai,
                menuFilho: this.menu
            }
            return dados;
        },
        // Recebe os dados do Menu.vue
        setDados(dadosMenu) { 
            this.principal = true;            
            let permDesativadas = clonar(dadosMenu.permissoesDesativadas);         
            permDesativadas.forEach(perm => {
                if(!perm.principal) { // A principal permissão do menu não pode ser editada
                    perm['idTeste'] = this.indexIdTeste++;
                    this.permissoesDesativadas.push(perm);
                }
            });
            let permiAtivasNovas = clonar(dadosMenu.permissoesAtivasNovas);
            permiAtivasNovas.forEach(perm => {
               if(!perm.principal) { // A principal permissão do menu não pode ser editada
                    perm['idTeste'] = this.indexIdTeste++;
                    this.permissoesAtivasNovas.push(perm);
                }
            });
            if(dadosMenu.menu != null) {
                this.menu = {...dadosMenu.menu};
            }  
            this.menuPai = null;       
            if(typeof dadosMenu.menuPai === 'undefined') {
                this.principal = true;               
            }       
            if(typeof dadosMenu.menuPai !== 'undefined' && dadosMenu.menuPai.id != null) {
                this.principal = false;
                this.menuPai = {...dadosMenu.menuPai};
            }             
        },
        desativarPermissao() {        
          let indexExcluir = 0;
          if(this.permissaoAtivaSelecionada) {
              this.permissoesAtivasNovas.forEach((perm, i) => {
                  if(perm.idTeste == this.permissaoAtivaSelecionada.idTeste) {
                      indexExcluir = i;
                  }
              });
              this.permissoesAtivasNovas.splice(indexExcluir, 1);                
              if(this.permissaoAtivaSelecionada.id != null) {
                  this.permissaoAtivaSelecionada.ativo = false;
                  this.permissoesDesativadas.push(this.permissaoAtivaSelecionada);
              }  
              this.permissaoAtivaSelecionada = null;        
          }
        },
        reativarPermissao() {        
            let indexExcluir = 0;
            this.permissoesDesativadas.forEach((perm, i) => {
                if(perm.idTeste == this.permissaoDesativadaSelecionada.idTeste) {
                    indexExcluir = i;
                }
            });
            this.permissoesDesativadas.splice(indexExcluir, 1);     
            this.permissaoDesativadaSelecionada.ativo = true;
            this.permissaoDesativadaSelecionada.descricao = '(Editado) - '+this.permissaoDesativadaSelecionada.descricao;          
            this.permissoesAtivasNovas.push(this.permissaoDesativadaSelecionada);
            this.permissaoDesativadaSelecionada = null; 
        },
        validarMenuPrinciapl() {
            if(this.menuPai == null) {
                this.principal = true;
            }
        }, 
        incluirPermissao() {
            this.enviandoForm = true;
            if(this.permissao.nome != '' && this.permissao.nomeOperacao != '') {
                if(this.permissao.id == null) {
                    // Permissao nova é uma permissão ativa mas não publicada (relacionou com o perfil de um plano ou usuári(s))
                    this.permissao['descricao'] = '(Nova) '+this.permissao.nome+' - '+this.permissao.nomeOperacao;
                    this.permissao['idTeste'] = this.indexIdTeste++;                
                    this.permissoesAtivasNovas.push(this.permissao);  
                } else {          
                    this.permissoesAtivasNovas.forEach(perm => {                        
                        if(perm.idTeste == this.permissao.idTeste) {                                                      
                            perm.nome = this.permissao.nome;
                            perm.nomeOperacao = this.permissao.nomeOperacao;
                            perm.descricao = '(Editado) - '+this.permissao.codigo+' - '+this.permissao.nome+' - '+this.permissao.nomeOperacao;
                            this.permissaoAtivaSelecionada = null;
                        }
                    });
                }           
                this.fecharModalPermissao();
            }
        },
        cancelarExcluirPermissao() {
            let indexExcluir = 0;
            this.permissoesExcluir.forEach((perm, i) => {
                if(perm.idTeste == this.permissaoExcluirSelecionada.idTeste) {
                    indexExcluir = i;
                }
            });
            this.permissoesExcluir.splice(indexExcluir, 1);          
            this.permissoesAtivasNovas.push(this.permissaoExcluirSelecionada);
            this.permissaoExcluirSelecionada = null; 

        },
        excluirPermissao() {
            let indexExcluir = 0;
            if(this.permissaoAtivaSelecionada) {
                if(this.permissaoAtivaSelecionada.publicado) {
                    exibirMensagemSis(this, 'Não é possível exlcuir uma permissão publicada', true);
                    return;
                }
                this.permissoesAtivasNovas.forEach((perm, i) => {
                    if(perm.idTeste == this.permissaoAtivaSelecionada.idTeste) {
                        indexExcluir = i;
                    }
                });
                this.permissoesAtivasNovas.splice(indexExcluir, 1);                
                if(this.permissaoAtivaSelecionada.id != null) {                   
                    this.permissoesExcluir.push(this.permissaoAtivaSelecionada);
                }  
                this.permissaoAtivaSelecionada = null;        
            }
        },
        exibirModalPermissao(nova) {
            this.tituloPermissao = 'Nova Permissão';
            if(this.permissaoAtivaSelecionada != null && !nova) {
                this.tituloPermissao = 'Editar Permissão';
                this.permissao = {...this.permissaoAtivaSelecionada};
            }
            this.exibirDialogPermissao = true;
        },
        fecharModalPermissao() {     
            this.enviandoForm = false;
            this.exibirDialogPermissao = false;  
            this.permissao = new Permissao();               
        }, 
    },
    created() {    
        this.setDados(this.receberDados());
    },
}
</script>

<style>

</style>